import axiosInstance from "../../../interceptor/intercetptor-inctence";

export const getUserList = (formData) => {
    return axiosInstance.post(`api/lab-user/lab-user-list`, formData);
}

export const addLabUser = (formData) => {
    return axiosInstance.post(`api/lab-user/register-lab-user`, formData);
}

export const statusUser = (id,form_data) => {
    return axiosInstance.post(`api/lab-user/toggle-user-status/${id}`, form_data);
}

export const deleteUser = (id) => {
    return axiosInstance.post(`api/lab-user/delete/${id}`, {});
}

export const updatUser = (id, formData) => {
    return axiosInstance.post(`api/lab-user//update-profile/${id}`, formData);
}

export const viewUser = (id) => {
    return axiosInstance.post(`api/lab-user/view-profile-by-id/${id}`, {});
}

export const generate = () => {
    return axiosInstance.post(`api/lab-user/generatePassword`, {});
}
